import useLocalStore from '../../../hooks/useLocalStore';
import FJFaceSwapLeftRight from './FJFaceSwapLeftRight';

const FJFaceSwapLeftRightContainer = () => {
    useLocalStore();

    return <FJFaceSwapLeftRight />;
};
export default FJFaceSwapLeftRightContainer;
